module.exports = __webpack_public_path__ + "static/media/job-3.69368e64.png";